import '@web-components/modal';

const VIDEO_MODAL_SELECTOR = 'modal-context[data-video-modal]';

const getModalVideo = (target: EventTarget | null): HTMLVideoElement | null => {
  if (!(target instanceof HTMLElement)) return null;
  if (!target.matches(VIDEO_MODAL_SELECTOR)) return null;

  return target.querySelector<HTMLVideoElement>('video');
};

document.addEventListener('modal:open', (event: Event) => {
  const video = getModalVideo(event.target);
  if (!video) return;

  void video.play();
});

document.addEventListener('modal:close', (event: Event) => {
  const video = getModalVideo(event.target);
  if (!video) return;

  video.pause();
  video.currentTime = 0;
});
